export enum ClientDiscountColumnIdentifier {
  ClientName = 'clientName',
  Category = 'category',
  Activity = 'activity',
  Discount = 'discount',
  Actions = 'actions'
}
